/*global $*/
import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { callService, formatDateDMA, makeform, goTo } from "./../tools";
import { servicios } from "./../properties";
import { relativeTimeThreshold } from "moment";
import { getBeneficiosGnp } from './beneficios.act';

const mapState = (state) => {
    return {
        beneficiosGnp: state.beneficiosGnp.listaBeneficios,
        showBeneficiosText:state.beneficiosGnp.showBeneficiosText,
        dispositivo: state.global.dispositivo,
        "clienteunico": state.global.uid
    };
};

const mapDispatch = (dispatch) => {
    return {
        loader: (show) => {
            dispatch({ "type": "LOADER", "show": show });
        },
        tagManager: (oDataTagManager) => {
            dispatch(oDataTagManager);
        },
        getBeneficiosGnp: () => {
            dispatch(getBeneficiosGnp());
        }
    };
};

class Beneficios extends React.Component {

    state = {
        mostrarDetalle: false,
        listaBeneficios: [],
        showBeneficiosText:''
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            listaBeneficios: nextProps.beneficiosGnp, 
            showBeneficiosText:nextProps.showBeneficiosText
        });
    };

    componentWillMount = () => {
        this.props.getBeneficiosGnp();
    };

    mostrarDetalle(beneficio) {
        console.log("entré");
        this.setState({
            mostrarDetalle: true,
            detalleBeneficio: beneficio
        })
    };

    volver(ev) {
        this.setState({
            mostrarDetalle: false
        })
    };

    render() {
        if(servicios.dominio === "gc-qa.gnp.com.mx"){
            var url = "https://dev.gnp.com.mx/content/gnp-pp/mx/es/gnp-movil/beneficios.html?c="
        } else if(servicios.dominio ==="gc-uat.gnp.com.mx"){
            var url = "https://qa.gnp.com.mx/content/gnp-pp/mx/es/gnp-movil/beneficios.html?c="
        } else{
            var url = "https://www.gnp.com.mx/content/gnp-pp/mx/es/gnp-movil/beneficios.html?c="
        }
        url += this.props.clienteunico + "&os=" + this.props.dispositivo;
        return (
            <div className="container">
            {/* { this.state.listaBeneficios.length > 0 ?
                <div className="container">
                { !this.state.mostrarDetalle ?
                    <div className="clearfix">
                        <h1 style={{ "color": "#FF8441" }}>Autos</h1>
                        <div className="cards-wrap mt-25 border-box">
                            { this.state.listaBeneficios.map(( beneficio, i ) =>
                                <div key={i} className="col-md-4 col-xs-12" onClick={() => this.mostrarDetalle(beneficio)}>
                                    <div className="card-beneficio select-card" >
                                        <div className="pull-left cupon">
                                            <img className="img-responsive" src={require('./../img/smart-trip.png')} />
                                        </div>
                                        <div className="clearfix">
                                            <div className="card-beneficio-content">
                                                <h6 style={{ "color": "#183d7d" }}>Distintivo bajo kilometraje</h6>
                                                <p><img src={require("../img/icon_poliza.png")} alt="" /><b> No. Póliza: {beneficio.numPoliza}</b></p>
                                                <p>Bonificación de ${((beneficio.montoSinIVA) + (beneficio.montoIVA)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} pesos</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                :
                    <div className="col-md-12 col-xs-12">
                        <div className="card">
                            <img className="pull-left" src={require("./../img/arrow-back.svg")} onClick={this.volver.bind(this)} alt="volver" style={{ "marginTop": "5px", "padding-right": "10px", "cursor": "pointer" }} />
                            <div className="clearfix" style={{ "marginTop": "-10px" }}>
                                <h5><img src={require('./../img/cupon.svg')} style={{ "height": "25px", "width": "40px" }} alt="" /> Detalle del código de bonificación</h5>
                                <h6>Distintivo bajo kilometraje</h6>
                                <hr></hr>
                                <table>
                                    <tr>
                                        <td style={{ "padding-right": "15px" }}>No. Póliza: </td>
                                        <td style={{ "color": "#183d7d" }}>{this.state.detalleBeneficio.numPoliza}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ "padding-right": "15px" }}>Código de bonificación: </td>
                                        <td style={{ "color": "#183d7d" }}>{this.state.detalleBeneficio.codigoCupon}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ "padding-right": "15px" }}>Monto: </td>
                                        <td style={{ "color": "#183d7d" }}>${((this.state.detalleBeneficio.montoSinIVA) + (this.state.detalleBeneficio.montoIVA)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ "padding-right": "15px" }}>Válido hasta: </td>
                                        <td style={{ "color": "#183d7d" }}>{moment(this.state.detalleBeneficio.fchFinVigenciaCupon).format("DD/MM/YYYY")}</td>
                                    </tr>
                                    <hr></hr>
                                    <tr>
                                        <td style={{ "padding-right": "15px" }}>Monto utilizado: </td>
                                        <td style={{ "color": "#183d7d" }}>${(((this.state.detalleBeneficio.montoSinIVA) + (this.state.detalleBeneficio.montoIVA)) - this.state.detalleBeneficio.saldoCupon).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ "padding-right": "15px" }}>Saldo: </td>
                                        <td style={{ "color": "#183d7d" }}>${(this.state.detalleBeneficio.saldoCupon).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</td>
                                    </tr>
                                </table>
                            </div>
                            {this.props.dispositivo === "web" ?
                            <div style={{ "margin-top": "100px" }}>
                                <p>Este código también está disponible en la sección Beneficios de la aplicación Soy Cliente GNP.</p>                              
                                <p>Consulta cómo utilizar tu código de bonificación <a target="_blank" href="https://www.gnp.com.mx/personas/auto/distintivo-bajo-kilometraje"> <span className="orange-text">aquí</span> </a></p>
                            </div>
                            :
                            <div style={{ "margin-top": "100px" }}>
                                <p>Este código también está disponible en la sección Soy cliente del portal gnp.com.mx</p>   
                                <p>Consulta cómo utilizar tu código de bonificación <a target="_blank" href="https://www.gnp.com.mx/personas/auto/distintivo-bajo-kilometraje"> <span className="orange-text">aquí</span> </a></p>
                            </div>
                            }
                        </div>
                    </div>
                }
                </div>
            :
                <div className="clearfix text-center">
                    <h6 style={{ "color": "#183d7d" }}>{this.state.showBeneficiosText}</h6>
                </div>
            } */}
            <iframe frameBorder="0" scrolling="yes" style={{"overflow":"hidden","width":"100%"}} height="750" width="100%" src={url}/>
            </div>
        );
    }
}

export default connect(mapState, mapDispatch)(Beneficios);



// WEBPACK FOOTER //
// ./src/Beneficios/beneficios.cmpt.js